/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RtsIngestionProcessingStgGet$Params {
  env?: string;
}

export function rtsIngestionProcessingStgGet(http: HttpClient, rootUrl: string, params?: RtsIngestionProcessingStgGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, rtsIngestionProcessingStgGet.PATH, 'get');
  if (params) {
    rb.query('env', params.env, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

rtsIngestionProcessingStgGet.PATH = '/Rts/ingestion-processing-stg';
